import { render } from "./ForgeHub.vue?vue&type=template&id=477f3c4c&scoped=true&ts=true"
import script from "./ForgeHub.vue?vue&type=script&lang=ts"
export * from "./ForgeHub.vue?vue&type=script&lang=ts"

import "./ForgeHub.vue?vue&type=style&index=0&id=477f3c4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477f3c4c"]])

export default __exports__